module.exports = __webpack_public_path__ + "static/img/fw_pic3.d2b7377.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/nav/fw_pic3.jpg
// module id = yfiD
// module chunks = 37